import dynamic from 'next/dynamic'
export default dynamic(() => import('./store-map'), {
  ssr: false,
})
